
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/directory",
      function () {
        return require("private-next-pages/[lang]/directory/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/directory"])
      });
    }
  